export const allowedRoles = ['Super Admin', 'Dashboard User']
